/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Supported list kinds:   * `PhvInsurer`   - List of insurer companies, for previous insurance private liability.   * `CarInsurer`   - List of insurer companies, for previous insurance car.
 */
export const ListKind = {
  PhvInsurer: 'PhvInsurer',
  CarInsurer: 'CarInsurer',
} as const;
export type ListKind = (typeof ListKind)[keyof typeof ListKind];
